export default function health_check_cal(
  section = null,
  data = null,
  criterion = null
) {
  // section = หัวข้อที่ตรวจ, data = ค่าที่ตรวจได้, criterion = เกณฑ์
  try {
    let result = null;
    let text = "";
    let text_extra = ""
    if (section === "BMI") {
      if (
        data.height !== "" &&
        data.weight !== "" &&
        data.height.length > 2 &&
        String(data.weight).length > 1
      ) {
        result = (
          parseFloat(data.weight) /
          (((parseFloat(data.height) / 100) * parseFloat(data.height)) / 100)
        ).toFixed(2);
        // if (result < 18.5) {
        //   text_extra = "อยู่ในเกณฑ์น้ำหนักน้อยหรือผอม"
        //   text = `ค่า ${result} อยู่ในเกณฑ์น้ำหนักน้อยหรือผอม น้ำหนักน้อยกว่าปกติก็ไม่ค่อยดีหากคุณสูงมากแต่น้ำหนักน้อยเกินไปอาจเสี่ยงต่อการได้รับสารอาหารไม่เพียงพอหรือได้รับพลังงานไม่เพียงพอส่งผลให้ร่างกายอ่อนเพลียง่ายการรับประทานอาหารให้เพียงพอและออกกำลังกายแบบเวทเทรนนิ่งเพื่อเสริมสร้างกล้ามเนื้อสามารถช่วยเพิ่มค่า BMI ให้อยู่ในเกณฑ์ปกติได้`
        // } else if (result >= 18.5 && result < 23) {
        //   text_extra = "อยู่ในเกณฑ์ปกติ"
        //   text = `ค่า ${result} อยู่ในเกณฑ์ปกติ น้ำหนักที่เหมาะสมสำหรับคนไทยคือค่า BMI ระหว่าง 18.5-22.9 จัดอยู่ในเกณฑ์ปกติห่างไกลโรคที่เกิดจากความอ้วนและมีความเสี่ยงต่อการเกิดโรคต่างๆ น้อยที่สุดควรพยายามรักษาระดับค่า BMI ให้อยู่ในระดับนี้ให้นานที่สุด`
        // } else if (result >= 23 && result < 25) {
        //   text_extra = "น้ำหนักเกิน"
        //   text = `ค่า ${result} อยู่ในเกณฑ์น้ำหนักเกิน พยายามอีกนิดเพื่อลดน้ำหนักให้เข้าสู่ค่ามาตรฐานเพราะค่า BMI ในช่วงนียังถือว่าเป็นกลุ่มผู้ที่มีความอ้วนอยู่บ้างแม้จะไม่ถือว่าอ้วนแต่หากประวัติคนในครอบครัวเคยเป็นโรคเบาหวานและความดันโลหิตสูงก็ถือว่ายังมีความเสี่ยงมากกว่าคนปกติ`
        // } else if (result >= 25 && result < 30) {
        //   text_extra = "อ้วนระดับที่ 1"
        //   text = `ค่า ${result} อยู่ในเกณฑ์อ้วนระดับที่ 1 ถึงแม้จะไม่ถึงเกณฑ์ที่ถือว่าอ้วนมาก ๆ แต่ก็ยังมีความเสี่ยงต่อการเกิดโรคที่มากับความอ้วนได้เช่นกันทั้งโรคเบาหวานและความดันโลหิตสูง`
        // } else if (result >= 30 ) {
        //   text_extra = "อ้วนระดับที่ 2"
        //   text = `ค่า ${result} อยู่ในเกณฑ์อ้วนระดับที่ 2 ค่อนข้างอันตรายเพราะเข้าเกณฑ์อ้วนมากเสี่ยงต่อการเกิดโรคร้ายแรงที่แฝงมากับความอ้วนหากค่า BMI อยู่ในระดับนี้จะต้องระวังการรับประทานไขมันและควรออกกำลังกายอย่างสม่ำเสมอและหากเลขยิ่งสูงกว่า40ยิ่งแสดงถึงความอ้วนที่มากขึ้น`
        // } 
        // if (data.summaryPhysical) {
        //   text = data.summaryPhysical
        // }
      }
    } else if (section === "LiverFunction" || section === "item_laboratory") {
      if (data && data.length > 0) {
        if (criterion.min > parseFloat(data)) {
          result = "ต่ำกว่าปกติ";
        } else if (criterion.max < parseFloat(data)) {
          result = "สูงกว่าปกติ";
        } else {
          result = "ปกติ";
        }
      }
    } else if (section == "BP"){
      if (data.summaryBpPuls){
        text = data.summaryBpPuls
      } else {
        if (data.bp_up < 120 && data.bp_down <  80){
          text_extra = "ความดันโลหิตอยู่ในเกณ์ปกติ"
          text = "ความดันโลหิตอยู่ในเกณ์ปกติ";
        } else if ((data.bp_up >= 120 && data.bp_up < 130) && (data.bp_down >= 80 && data.bp_down < 85)){
          text_extra = "ความดันโลหิตปกติ"
          text = "ความดันโลหิตปกติ";
        } else if ((data.bp_up >= 130 && data.bp_up < 140) && (data.bp_down >= 85 && data.bp_down < 90)){
          text_extra = "ความดันโลหิตค่อนข้างสูง"
          text = "ความดันโลหิตค่อนข้างสูง";
        } else if ((data.bp_up >= 140 && data.bp_up < 160) && (data.bp_down >= 90 && data.bp_down < 100)){
          text_extra = "ความดันโลหิตสูงเล็กน้อย"
          text = `ความดันโลหิตสูงเล็กน้อย (ระยะที่1) ความดันโลหิตสูงหมายถึงภาวะความดันโลหิตที่วัดได้ค่ามากกว่า 140/90 มม.ปรอทซึ่งอาจไม่แสดงอาการแต่จะเป็นสาเหตุทำให้เกิดภาวะแทรกซ้อนต่างๆ เช่น โรคหัวใจ โรคหลอดเลือดสมอง เส้นเลือดแดงใหญ่โป่งพอง ไตวาย เป็นต้น ส่วนหนึ่งอาจเกิดจากความอ้วนหรือผู้ที่รับประทานอาหารรสเค็มจัดความเครียด`;
        } else if ((data.bp_up >= 160 && data.bp_up < 180) && (data.bp_down >= 100 && data.bp_down < 110)){
          text_extra = "ความดันโลหิตสูงปานกลาง"
          text = `ความดันโลหิตสูงปานกลาง (ระยะที่2) ความดันโลหิตสูงหมายถึงภาวะความดันโลหิตที่วัดได้ค่ามากกว่า 140/90 มม.ปรอทซึ่งอาจไม่แสดงอาการแต่จะเป็นสาเหตุทำให้เกิดภาวะแทรกซ้อนต่างๆ เช่น โรคหัวใจ โรคหลอดเลือดสมอง เส้นเลือดแดงใหญ่โป่งพอง ไตวาย เป็นต้น ส่วนหนึ่งอาจเกิดจากความอ้วนหรือผู้ที่รับประทานอาหารรสเค็มจัดความเครียด`;
        } else if (data.bp_up >= 180 && data.bp_down >= 110){
          text_extra = "ความดันโลหิตสูงมาก"
          text = `ความดันโลหิตสูงมาก (ระยะที่3) ความดันโลหิตสูงหมายถึงภาวะความดันโลหิตที่วัดได้ค่ามากกว่า 140/90 มม.ปรอทซึ่งอาจไม่แสดงอาการแต่จะเป็นสาเหตุทำให้เกิดภาวะแทรกซ้อนต่างๆ เช่น โรคหัวใจ โรคหลอดเลือดสมอง เส้นเลือดแดงใหญ่โป่งพอง ไตวาย เป็นต้น ส่วนหนึ่งอาจเกิดจากความอ้วนหรือผู้ที่รับประทานอาหารรสเค็มจัดความเครียด`;
        }
      }
    }
    return { result: result, text: text,text_extra:text_extra };
  } catch (error) {
    console.log("health_check_cal function error:", error);
  }
}
